<div
  class="aprova-radio"
  [class.aprova-radio--checked]="checked"
  [class.aprova-radio--left-label]="leftLabel"
  [class.aprova-radio--disabled]="disabled"
  [style.--radio-color]="color"
>
  <div class="aprova-radio__container">
    <div class="aprova-radio__outer-circle"></div>
    <div class="aprova-radio__inner-circle"></div>
    <input
      [id]="id"
      type="radio"
      [name]="name"
      [value]="value"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onInputChange($event)"
    />
  </div>
  <label
    [for]="id"
    class="aprova-radio__label"
    [class]="labelClass"
    [class.aprova-radio__label--disabled]="disabled"
  >
    {{ label }}
  </label>
</div>
